import {
	GET_ACTION_UPDATES,
	FETCH_ACTION_UPDATE,
	GET_UPDATES_ACTIVITY_FEED,
} from "constants/actions";

const initialState = {
	updates: [],
	activity_feed: [],
	pageNumber: 1,
	pending: false,
	queryParams: [],
};

export default function ActionUpdates(state = initialState, action) {
	switch (action.type) {
		case GET_ACTION_UPDATES:
			return {
				...state,
				updates: action.payload,
				pending: false,
			};

		case FETCH_ACTION_UPDATE:
			return {
				...state,
				[action.payload.id]: action.payload,
				pending: false,
			};

		case GET_UPDATES_ACTIVITY_FEED:
			return {
				...state,
				activity_feed: action.payload,
				pending: false,
			};

		default:
			return state;
	}
}

